/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseProduct } from '../../models/api-response-product';

export interface RemoveProductTag$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
  ref: string;
  tagref: string;
}

export function removeProductTag(http: HttpClient, rootUrl: string, params: RemoveProductTag$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseProduct>> {
  const rb = new RequestBuilder(rootUrl, removeProductTag.PATH, 'delete');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.path('ref', params.ref, {});
    rb.path('tagref', params.tagref, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseProduct>;
    })
  );
}

removeProductTag.PATH = '/v1/api/products/{ref}/tag/{tagref}';
